import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import '../assets/styles/Chatbot.css';
import '../assets/styles/KnowledgeBase.css';
import { FaBars, FaRegWindowClose } from 'react-icons/fa';

const Layout = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className='row app-layout m-0'>
        <div className={`sidebar-content ${isOpen ? 'sidebar--open' : ''}`}>
          <Sidebar />
          <div className='sidebar-toggle set-sidebar-toggle' onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <FaRegWindowClose /> : ''}
          </div>
        </div>
        <div className='main-content p-0'>
          <div className='sidebar-toggle' onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? '' : <FaBars />}
          </div>
          <div className='content-wrapper d-flex' id='sidebar-wrapper'>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
